import $api from "../../../http";
import { MyPlace } from "../types";

/**
 * `Ф3` (кабинет ПЗС): свой профиль, места, пароль и согласие.
 *
 * Субъект — из сессии, `id` в путях нет. Правка профиля принимает только
 * `lastName`, `firstName`, `surName`, `tel`; почта — только чтение (`Л9`).
 */

export type MyConsent = {
  has_consent: boolean;
  version: string | null;
  accepted_at: string | null;
  text: string | null;
  has_newer_version: boolean;
  document_code: string;
  current_version: string | null;
};

export type ProfileEditable = {
  lastName?: string;
  firstName?: string;
  surName?: string;
  tel?: string;
};

export default class CabinetProfileApi {
  static async getPlaces(): Promise<MyPlace[]> {
    const response = await $api.get<MyPlace[]>("/my/places", {
      withCredentials: true,
    });

    return response.data;
  }

  static async updateProfile(payload: ProfileEditable): Promise<void> {
    await $api.patch("/my/profile", payload, { withCredentials: true });
  }

  static async changePassword(payload: {
    currentPassword: string;
    newPassword: string;
  }): Promise<{ changed: boolean }> {
    const response = await $api.post("/my/password", payload, {
      withCredentials: true,
    });

    return response.data;
  }

  static async getConsent(): Promise<MyConsent> {
    const response = await $api.get<MyConsent>("/my/consent", {
      withCredentials: true,
    });

    return response.data;
  }
}
